import { Inputfiledsbase } from './models/inputfiledsbase';

export class MultiSelectQuestion extends Inputfiledsbase<string> {
  override controlType = 'multiselect';
}